<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
                <md-icon>receipt_long</md-icon>
            </div>
        </md-card-header>
        <md-card-content>
            <p v-if="!lines || lines.length === 0" class="grayedout-text">
                No item provided.
            </p>
            <div v-else>
                <md-table class="context-menu-support custom-paginated-table">
                    <md-table-row>
                        <md-table-head>Description</md-table-head>
                        <md-table-head>Quantity</md-table-head>
                        <md-table-head>Unit Cost (Ex-Tax)</md-table-head>
                        <md-table-head>Total Amount (Ex-Tax)</md-table-head>
                        <md-table-head>Ref</md-table-head>
                        <md-table-head>Trip Date</md-table-head>
                        <md-table-head>Stop Status</md-table-head>
                        <md-table-head>Action</md-table-head>
                    </md-table-row>
                    <md-table-row v-for="(line, index) in lines" :key="index">
                        <md-table-cell>{{ line.description }}</md-table-cell>
                        <md-table-cell>
                            {{ displayLineValue(line) }}
                            <span class="quantity-type">{{ line.quantityType }}</span>
                        </md-table-cell>
                        <md-table-cell>{{ line.unitPriceExTax | currency(line.priceCurrency) }}</md-table-cell>
                        <md-table-cell>
                            {{ (line.unitPriceExTax * line.quantity) | currency(line.priceCurrency) }}
                        </md-table-cell>
                        <md-table-cell>
                            <router-link
                                v-if="line.stopId"
                                :to="{ name: 'Stop Details', params: { stopId: line.stopId } }"
                                target="_blank"
                            >
                                {{ line.stopRef }}
                            </router-link>
                            <router-link
                                v-if="line.shipmentId"
                                :to="{ name: 'Shipment Details', params: { shipmentId: line.shipmentId } }"
                                target="_blank"
                            >
                                {{ line.shipmentRef }}
                            </router-link>
                            <router-link
                                v-if="line.tripId"
                                :to="{ name: 'Trip Details', params: { tripId: line.tripId } }"
                                target="_blank"
                            >
                                {{ line.tripRef }}
                            </router-link>
                        </md-table-cell>
                        <md-table-cell>
                            {{ line.tripDate | dateFormat(DATE_TYPES.standardDate) }}
                        </md-table-cell>
                        <md-table-cell>
                            {{ line.stopStatus ? $t('inputs.stopStatuses.' + line.stopStatus) : line.stopStatus }}
                        </md-table-cell>
                        <md-table-cell>
                            <create-issue
                                v-if="line.stopId || line.shipmentId || line.tripId"
                                v-feature="FEATURE_NAMES.IssueTracking"
                                :related-entity-type="$_issueRelatedEntityType(line)"
                                :related-entity-ref="$_issueRelatedEntityReference(line)"
                            />
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { FEATURE_NAMES } from '@/utils/constants';
import { CreateIssue } from '@/pages/Issues/Components';

export default {
    name: 'InvoiceLines',
    mixins: [GeneralMixin],
    components: {
        CreateIssue
    },
    props: {
        lines: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            FEATURE_NAMES
        };
    },
    methods: {
        displayLineValue(line) {
            return line.stopCount ?? line.quantity;
        }
    }
};
</script>
